import React from 'react';
import { useLanguage, type Lang } from '../../i18n/LanguageContext';
const OPTIONS: {
  code: Lang;
  label: string;
  full: string;
}[] = [{
  code: 'es',
  label: 'ES',
  full: 'Español'
}, {
  code: 'en',
  label: 'EN',
  full: 'English'
}];
type LanguageSwitcherProps = {
  tone?: 'dark' | 'light';
};
export function LanguageSwitcher({
  tone = 'dark'
}: LanguageSwitcherProps) {
  const {
    lang,
    setLang,
    t
  } = useLanguage();
  const base = tone === 'dark' ? 'border-navy-100 text-charcoal-light' : 'border-white/20 text-navy-100/70';
  return <div role="group" aria-label={t.nav.language} className={`flex items-center gap-0.5 rounded-full border p-0.5 ${base}`} data-id="element-283" data-mp="3nto28cgrl19a">
      {OPTIONS.map(opt => {
      const active = lang === opt.code;
      return <button key={opt.code} type="button" onClick={() => setLang(opt.code)} aria-pressed={active} title={opt.full} className={`rounded-full px-2.5 py-1 text-[11px] font-semibold uppercase tracking-[0.12em] transition-colors duration-200 ${active ? 'bg-navy text-gold' : tone === 'dark' ? 'hover:text-navy' : 'hover:text-gold'}`} data-id="element-284" data-mp="1hy3hkfqbgnr5">
            {opt.label}
            <span className="sr-only" data-id="element-285" data-mp="10b2cn1n2v6bj"> — {opt.full}</span>
          </button>;
    })}
    </div>;
}